import type { SearchLocationMode } from "@/api/types";

export interface SearchBarState {
  query: string;
  category: string | null;
  categoryName: string | null;
  location: string | null;
  lat: number | null;
  lng: number | null;
  bounds: string | null;
  locationMode: SearchLocationMode | null;
  whenDate: string | null;
  whenTime: string | null;
}

export interface RecentSearch {
  q?: string;
  category?: string;
  categoryName?: string;
  location?: string;
  lat?: number;
  lng?: number;
  bounds?: string;
  location_mode?: SearchLocationMode;
  when_date?: string;
  when_time?: string;
}

export const RECENT_SEARCHES_KEY = "slotique_recent_searches";
export const RECENT_SEARCHES_MAX = 5;
export const DEBOUNCE_MS = 300;

export const TIME_OPTIONS = [
  { value: "any", label: "Any time" },
  { value: "morning", label: "Morning" },
  { value: "afternoon", label: "Afternoon" },
  { value: "evening", label: "Evening" },
] as const;
